import * as TYPES from "../actions/types";

const INITIAL_STATE = {
  question_list: [],
  current_sheet: "questions",
  topic: "All",
  solved: "All",
  favourites: "All",
  loading: false,
  searchString: "",
  version: 3,
};

const questionReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case TYPES.FETCH_QUESTIONS:
      return { ...state, question_list: [...action.payload] };
    case TYPES.UPDATE_SOLVED:
      return { ...state, question_list: [...action.payload] };
    case TYPES.CHECK_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    case TYPES.UPDATE_FILTER_FAV:
      return {
        ...state,
        favourites: action.payload,
      };
    case TYPES.UPDATE_FILTER_TOPIC:
      return {
        ...state,
        topic: action.payload,
      };
    case TYPES.UPDATE_FILTER_SOLVED:
      return {
        ...state,
        solved: action.payload,
      };
    case TYPES.UPDATE_SEARCH_STRING:
      return {
        ...state,
        searchString: action.payload,
      };
    case TYPES.UPDATE_FAVOURITE:
      return {
        ...state,
        question_list: [...action.payload],
      };
    default:
      return state;
  }
};

export default questionReducer;
